import { NextRequest, NextFetchEvent } from 'next/server';

import { v4 as uuidV4 } from 'uuid';
import { generateCookieDomain } from '../utils/cookies/generateCookieDomain';
import { generateCookieExpire } from '../utils/cookies/generateCookieExpire';

import type { MiddlewareFactory } from './type';

const CLIENT_ID_COOKIE_KEY = 'client_ident';

export const clientIdMiddleware: MiddlewareFactory = (next, response) => {
  return (req: NextRequest, event: NextFetchEvent) => {
    if (!req.cookies.get(CLIENT_ID_COOKIE_KEY)) {
      response.cookies.set(CLIENT_ID_COOKIE_KEY, uuidV4(), {
        expires: generateCookieExpire(6, 'months'),
        domain: generateCookieDomain(),
      });
    }

    return next(req, event);
  };
};
